import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SUPPORTED_LANGUAGES } from './language.service';

const version = require('../../../../package.json').version;

type LoadedLanguages = { [k in (typeof SUPPORTED_LANGUAGES)[number]]?: boolean };

@Injectable()
export class MatildaTranslateLoader implements TranslateLoader {
  loaded: BehaviorSubject<LoadedLanguages>;
  loaded$: Observable<LoadedLanguages>;

  constructor(private http: HttpClient) {
    this.loaded = new BehaviorSubject({});
    this.loaded$ = this.loaded.asObservable();
  }

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json?v=${version}`).pipe(
      tap(() =>
        this.loaded.next({
          ...this.loaded.value,
          [lang]: true
        })
      )
    );
  }
}
